var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineaEticaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.46,
    height: 46.818,
    viewBox: "0 0 60.46 46.818",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583",
    transform: "translate(-1071.242 -2598.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    d: "M319.028 46.74a4.568 4.568 0 0 1 2.114.534c1.09.512 2.381 1.09 4.005 1.825 0 0 2.581-1.825 2.715-1.914a1.358 1.358 0 0 1 2 .356 47.316 47.316 0 0 1 3.738 8.9 1.012 1.012 0 0 1-.668 1.246 13.681 13.681 0 0 1-1.691.289c-.935.134-.912.868-.912 1.313 0 .556.045 4.317.045 5.607a3.423 3.423 0 0 1-3.6 3.4c-.2 0-6.943.045-6.92.045a4.729 4.729 0 0 1-4.762-4.45c-.025-1.508-.092-12.1-.092-13.301a4.013 4.013 0 0 1 4.028-3.85",
    className: "cls-1",
    "data-name": "Path 480",
    transform: "translate(793.937 2565.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    d: "M328.99 76.157l-22.475.156.022 2.448 26.369-.178a12.841 12.841 0 0 0 .913-4.583l-.111-16.667a3.976 3.976 0 0 1 3.271-4.139c.067-.022.156-.022.223-.045a35.157 35.157 0 0 1 20.338 1.624c.823.378 1-.267.979-.534a8.28 8.28 0 0 0-8.189-8.233 14.09 14.09 0 0 0-7.588 1.914.238.238 0 0 1-.267-.089 11.3 11.3 0 0 0-4.428-2.448.257.257 0 0 1 .022-.512 36.018 36.018 0 0 1 9.168.2c.334.067.6-.134.467-.445-.111-.245-.178-.356-.356-.712A4.15 4.15 0 0 0 344.789 42a59.137 59.137 0 0 0-13.6-1.58 68.182 68.182 0 0 0-12.75 1.446c-.356.089-.846.2-.935.223-.4.089-.49.445-.312.645.111.111.423.378.556.534a.592.592 0 0 1-.067.868l-10.1 9.057 6.965-.045h.067a.9.9 0 0 1 .045 1.8h-.067l-9.034.067-2.737 2.492 11.838-.067h.067a.893.893 0 0 1 0 1.78h-.067l-13.841.089-2.757 2.491 23.9-.156h.067a.916.916 0 0 1 .846.89.891.891 0 0 1-.823.935h-.067l-23.921.156.022 2.448 23.876-.156h.067a.9.9 0 0 1 .868.935.913.913 0 0 1-.868.846h-.067l-23.854.156v2.492l31.175-.2h.067a.888.888 0 0 1 .846.912.875.875 0 0 1-.823.868h-.071l-22.786.156.022 2.47 22.475-.156h.467c.423 0 .779.512.8.935a.871.871 0 0 1-.779.868z",
    className: "cls-1",
    "data-name": "Path 481",
    transform: "translate(773.182 2557.732)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    d: "M305.65 60.379l.022 2.514s3.382-.022 5.3-.045a13.828 13.828 0 0 0 7.855-2.559z",
    className: "cls-1",
    "data-name": "Path 482",
    transform: "translate(782.481 2582.077)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    d: "M305.64 58.491l.022 2.47 15.265-.111a12.788 12.788 0 0 0 1.825-2.47z",
    className: "cls-1",
    "data-name": "Path 483",
    transform: "translate(782.469 2579.737)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    d: "M305.2 61.4h.2c.156 0 .334 0 .334-.2 0-.156-.134-.2-.267-.2h-.267zm.022.645h-.156v-1.152h.445c.267 0 .378.111.378.312a.307.307 0 0 1-.289.334l.356.512h-.178l-.356-.512h-.222zm.223.289a.868.868 0 1 0-.89-.868.869.869 0 0 0 .89.868m-.022-1.869a1.013 1.013 0 1 1-1.024 1.024 1.016 1.016 0 0 1 1.024-1.024",
    className: "cls-1",
    "data-name": "Path 484",
    transform: "translate(780.95 2582.297)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineaEticaLogo);
export default __webpack_public_path__ + "static/media/linea-etica-logo.2c7770b5252137b2ddccc52f631ecb57.svg";
export { ForwardRef as ReactComponent };